import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import Paper from "@mui/material/Paper";
import SwapVertIcon from "@mui/icons-material/SwapVert";
import Box from "@mui/material/Box";
import PaginationRounded from "../Pagination/index";
function createData(name: string, subject: string, time: string, status: any) {
  return { name, subject, time, status };
}

const rows = [
  createData(
    "1",
    "Washing machine has finished the task",
    "01:24 PM on 5th July 2022 ",
    "Seen"
  ),
  createData(
    "2",
    "All gates are closed by Mary",
    "10:48 AM on 29th June 2022 ",
    "circle"
  ),
  createData(
    "3",
    "Jacob has unlocked the main door",
    "03:33 PM on 28th June 2022 ",
    "circle"
  ),
  createData(
    "4",
    "Jacob has unlocked the main door",
    "10:48 AM on 29th June 2022 ",
    "Seen"
  ),
  createData(
    "5",
    "Power consumption has been reduced for 10% this week",
    "01:24 PM on 5th July 2022 ",
    "circle"
  ),
  createData(
    "6",
    "All garage doors has been closed",
    "03:33 PM on 28th June 2022  ",
    "circle"
  ),
  createData(
    "7",
    "Air Conditioner in the living room has been set into the Eco Mode",
    "10:48 AM on 29th June 2022 ",
    "circle"
  ),
  createData(
    "8",
    "Mary has closed a Garage 1 door",
    "01:24 PM on 5th July 2022 ",
    "seen"
  ),
  createData(
    "9",
    "Playstation 5 has been turned on for 6 hours",
    "01:24 PM on 5th July 2022 ",
    "seen"
  ),
  createData(
    "10",
    "Air Conditioner in the living room has been set into the Quiet Mode",
    "07:34 AM on 30th June 2022  ",
    "seen"
  ),
  createData(
    "10",
    "All gates are opened by Jacob",
    "11:04 PM on 30th June 2022  ",
    "seen"
  ),
];
const bNone = { border: "none", fontSize: "20px" };
const bSize = { border: "none", fontSize: "16px" };
export default function BasicTable() {
  return (
    <>
      <TableContainer component={Paper}>
        <Table sx={{ minWidth: 650 }} aria-label="simple table">
          <TableHead>
            <TableRow>
              <TableCell sx={bNone}>
                <Box sx={{ display: "flex ", alignItems: "center" }}>
                  No <SwapVertIcon />
                </Box>
              </TableCell>
              <TableCell sx={bNone} align="left">
                Subject
              </TableCell>
              <TableCell sx={bNone} align="left">
                Time
              </TableCell>
              <TableCell sx={bNone} align="center">
                Status
              </TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {rows.map((row) => (
              <TableRow key={row.name}>
                <Box sx={{ ml: 1 }}>
                  <TableCell sx={bSize} component="th" scope="row">
                    {row.name}
                  </TableCell>
                </Box>
                <TableCell sx={bSize} align="left">
                  {row.subject}
                </TableCell>
                <TableCell sx={bSize} align="left">
                  {row.time}
                </TableCell>
                <TableCell sx={bSize} align="center">
                  <Box
                    sx={{
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                    }}
                  >
                    {row.status === "circle" ? <YellowCircle /> : "Seen"}
                  </Box>
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>

      <Box sx={{ display: "flex", justifyContent: "end", mt: 2 }}>
        <PaginationRounded />
      </Box>
    </>
  );
}
export const YellowCircle = ({ handleSeen, index }: any) => {
  return (
    <Box
      onClick={() => {
        handleSeen(index);
      }}
      sx={{
        height: "16px",
        width: "16px",
        borderRadius: "100%",
        backgroundColor: "#D4DD06",
        cursor: "pointer",
      }}
    ></Box>
  );
};
